import { NextRequest } from "next/server";
import { UAParser } from "ua-parser-js";
import { RequestContext, UtmParams } from "./types";

const SESSION_COOKIE_NAME = "personalization_session";
const USER_ID_COOKIE_NAME = "user_id";

function extractDeviceInfo(userAgent: string) {
  const parser = new UAParser(userAgent);
  const browser = parser.getBrowser();
  const os = parser.getOS();
  const device = parser.getDevice();

  return {
    deviceType: device.type || undefined,
    browser: browser.name || undefined,
    os: os.name || undefined,
  };
}

function extractUtmParams(request: NextRequest): UtmParams {
  const searchParams = request.nextUrl.searchParams;
  const utm: UtmParams = {};

  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith("utm_")) {
      utm[key as keyof UtmParams] = value;
    }
  }

  return utm;
}

// This would typically be replaced with a real geolocation service
// For now, we'll extract it from a header if available
function extractGeolocation(request: NextRequest) {
  const geoHeader = request.headers.get("x-geo-location");
  if (!geoHeader) return undefined;

  try {
    return JSON.parse(geoHeader);
  } catch {
    return undefined;
  }
}

export function collectRequestContext(request: NextRequest): RequestContext {
  const userAgent = request.headers.get("user-agent") || "";

  return {
    utm: extractUtmParams(request),
    device: extractDeviceInfo(userAgent),
    geolocation: extractGeolocation(request),
    userId: request.cookies.get(USER_ID_COOKIE_NAME)?.value,
    sessionId: request.cookies.get(SESSION_COOKIE_NAME)?.value,
    referrer: request.headers.get("referer") || undefined,
    // Add any custom attributes here if needed
    customAttributes: {},
  };
}
